import React from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, reduxForm, arrayPush, getFormValues } from 'redux-form';
import lodash from 'lodash'
import qs from 'qs'
import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableActionButton from "components/CustomToolbar/TableActionButton.jsx"
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";

import { listServices } from '../../../services'
import { promotionConstants } from "../../../constants"
import Button from "components/CustomButtons/Button.jsx";
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";
import CustomInput from 'components/CustomInput/CustomInput';
import { crmValidator, normalize } from 'helpers';
import { components, createFilter } from 'react-select';
import ReactAsyncSelect from 'react-select/async'
import red from '@material-ui/core/colors/red';

import debounce from "debounce-promise";

const style = {
    ...modalStyle,
    tdBordered: {
        border: "solid 1px #ccc"
    },
    tableError: {
        border: "solid 2px red"
    },
    optionHover: {
        backgroundColor: "#fff",
        "&:hover": {
            backgroundColor: "#eee"
        }
    },
    overrides: {
        MuiDialog: {
            paper: {
                overflowY: "visible"
            }
        }
    }
}

const THEME = createMuiTheme(style)

const FORM_NAME = 'promotion_reward_free_product'

const form_validate = {
}

const defaultCollectType = [{
    value: "sku",
    label: "SKU"
},
{
    value: "category",
    label: "Category"
}]

const validateRequired = (value, allValues, props, name) => {
    if (value === "" || value === null || value === undefined) {
        if (lodash.includes(name, 'qty')) {
            return "Quantity is required"

        } else if (lodash.includes(name, 'operator')) {
            return "Operator is required"

        } else if (lodash.includes(name, 'value')) {
            return "Special Price is required"

        } else {
            return "Required"
        }
    }

    if (parseFloat(value) <= 0) {
        return "Please enter number more than 0"
    }
}

const validate = (values) => {
    const errors = crmValidator.validateByRulesList(form_validate, values);
    return errors
}

const validateSizeMorethanOne = (value) => {
    if (lodash.size(value) === 0) {
        return 'Please add at least 1 condition'
    }
}

const MenuList = props => {
    let menuListType = lodash.get(props, 'selectProps.menuListType')
    return (
        <React.Fragment>
            <GridContainer style={{
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                borderBottom: "1px solid #aaa",
                backgroundColor: "rgb(255, 255, 255)",
                width: "100%",
                margin: "0px",
                padding: "8px 0px"
            }}>
                <GridItem xs={4}>{menuListType === "sku" ? "SKU ID" : "Category Code"}</GridItem>
                <GridItem xs={8}>{menuListType === "sku" ? "Product Name" : "Category Name"}</GridItem>
            </GridContainer>
            <components.MenuList {...props}>
                {props.children}
            </components.MenuList>
        </React.Fragment>
    );
};

class PromotionRewardFreeProduct extends React.Component {

    constructor(props) {
        super(props)
        const loadDelays = 800
        const loadProduct = inputValue => this.loadProductOptionsPromise(inputValue)
        this.loadProductOptionsDelay = debounce(loadProduct, loadDelays, {
            leading: true
        })

        const loadCategory = inputValue => this.loadCategoryOptionsPromise(inputValue)
        this.loadCategoryOptionsDelay = debounce(loadCategory, loadDelays, {
            leading: true
        })

        this.renderCustomOption = this.renderCustomOption.bind(this)
    }

    renderCustomOption = (props) => {
        const { classes } = this.props
        delete props.innerProps.onMouseMove;
        delete props.innerProps.onMouseOver;

        return (
            <components.Option {...props} className={classes.optionHover}>
                <GridContainer>
                    <GridItem xs={4}>{lodash.get(props, 'data.value')}</GridItem>
                    <GridItem xs={8}>{lodash.get(props, 'data.label')}</GridItem>
                </GridContainer>
            </components.Option>
        );
    };

    loadProductOptionsPromise(inputValue) {
        return new Promise(async (resolve, reject) => {
            let { formValues } = this.props
            let formValuesConditions = lodash.get(formValues, 'conditions')
            let selectedSKU = []

            lodash.forEach(formValuesConditions, function (value) {
                let orCondition = lodash.get(value, 'in')
                lodash.forEach(orCondition, function (cond) {
                    let selected = lodash.get(cond, 'id')
                    selectedSKU.push(selected)
                })
            })

            let reqParams = {
                skip: 0,
                limit: 1000,
                sortBy: "name",
                sortDir: "asc",
                keyword: inputValue,
                keywordFilterList: ["name", "skuId"]
            }
            let productList = await listServices.getListsProduct(qs.stringify(reqParams))
            let formattedProductList = []
            if (lodash.has(productList, 'data.products')) {
                productList.data.products.map((value) => {
                    let productsku = lodash.get(value, 'skuId')
                    if ((lodash.indexOf(selectedSKU, productsku) === -1) && productsku) {
                        formattedProductList.push({
                            value: productsku,
                            label: lodash.get(value, 'name')
                        })
                    }
                    return formattedProductList
                })
            }
            resolve(formattedProductList)
        });
    }

    loadCategoryOptionsPromise(inputValue) {
        return new Promise(async (resolve, reject) => {
            let { formValues } = this.props
            let formValuesConditions = lodash.get(formValues, 'conditions')
            let selectedCategory = []

            lodash.forEach(formValuesConditions, function (value) {
                let orCondition = lodash.get(value, 'in')
                lodash.forEach(orCondition, function (cond) {
                    let selected = lodash.get(cond, 'id')
                    selectedCategory.push(selected)
                })
            })

            let reqParams = {
                skip: 0,
                limit: 1000,
                sortBy: "name",
                sortDir: "asc",
                keyword: inputValue,
                keywordFilterList: ["categoryCode", "name"]
            }

            let categoryList = await listServices.getCategoryList('product', qs.stringify(reqParams))
            let formattedCategoryList = []
            if (lodash.has(categoryList, 'data.data') && lodash.isArray(categoryList.data.data)) {
                categoryList.data.data.map((value) => {
                    let catCode = lodash.get(value, 'categoryCode')
                    if ((lodash.indexOf(selectedCategory, catCode) === -1) && catCode) {
                        formattedCategoryList.push({
                            value: catCode,
                            label: lodash.get(value, 'name')
                        })
                    }
                    return formattedCategoryList
                })
            }
            resolve(formattedCategoryList)
        })
    }

    addCondition() {
        const { dispatch } = this.props
        dispatch(arrayPush(FORM_NAME, 'conditions', {
            "type": "sku",
            "operator": "OR"
        }))
    }

    addOrCondition(conditionIndex, value) {
        const { dispatch } = this.props
        return new Promise((resolve) => {
            dispatch(arrayPush(FORM_NAME, `conditions[${conditionIndex}].in`, {
                "id": lodash.get(value, 'value'),
                "name": lodash.get(value, 'label')
            }))
            resolve()
        })
    }

    getConditionIndexCollectype(conditionsIndex) {
        let { formValues } = this.props
        let formValuesConditions = lodash.get(formValues, 'conditions')
        let _thisConditionCollectype = lodash.get(formValuesConditions, `[${conditionsIndex}].type`)
        return _thisConditionCollectype
    }

    renderTableHead = (and, conditionsIndex) => {
        let { classes, readOnly, rewardModalOpen } = this.props
        let _thisConditionCollectype = this.getConditionIndexCollectype(conditionsIndex)
        return (
            <TableRow className={classes.tdBordered}>
                <TableCell>{(_thisConditionCollectype === "sku") ? "SKU ID" : "Category Code"}</TableCell>
                <TableCell>{(_thisConditionCollectype === "sku") ? "Product Name" : "Category Name"}</TableCell>
                <TableCell>{"Quantity"}</TableCell>
                {rewardModalOpen === 'special_price' &&
                    <TableCell>{"Special Price"}</TableCell>
                }
                <TableCell colSpan={2} align="center" style={{ padding: "10px" }}>
                    <Field
                        name={`${and}.operator`}
                        type="text"
                        component={CustomSelect}
                        formControlProps={{
                            fullWidth: true
                        }}
                        labelText={""}
                        outlined
                        optionsList={[{
                            value: "AND",
                            label: "AND"
                        }, {
                            value: "OR",
                            label: "OR"
                        }]}
                        disabled={readOnly}
                        validate={[validateRequired]}
                    />
                </TableCell>
            </TableRow>
        )
    }

    renderRewardCondition = ({ fields, meta: { error, submitFailed } }) => {
        const { classes, formValues, readOnly, rewardModalOpen } = this.props
        return (
            <React.Fragment>
                {fields.map((conditions, index) => (
                    <React.Fragment key={index}>
                        { (index > 0) &&
                            <div style={{
                                padding: "20px",
                                width: "68px",
                                background: "linear-gradient(#000, #000) no-repeat center/2px 100%",
                                textAlign: "center"
                            }}>
                                <b style={{ backgroundColor: "white" }}>{lodash.upperCase(lodash.get(formValues, 'operator'))}</b>
                            </div>
                        }
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow className={classes.tdBordered}>
                                    <TableCell
                                        key="condition_header"
                                        align="center"
                                        style={{
                                            paddingRight: "10px",
                                            minWidth: "160px",
                                            whiteSpace: "nowrap"
                                        }}>
                                        <Field
                                            name={`${conditions}.type`}
                                            component={CustomSelect}
                                            type="text"
                                            labelText={""}
                                            formControlProps={{
                                                fullWidth: true,
                                            }}
                                            outlined
                                            disabled={lodash.size(lodash.get(formValues, `conditions[${index}].in`)) > 0}
                                            optionsList={defaultCollectType}
                                        />
                                    </TableCell>
                                    <TableCell colSpan="3" style={{ paddingRight: "10px" }}>
                                        {!readOnly ?
                                            <>
                                                {lodash.get(formValues, `conditions[${index}].type`) === "sku" ?
                                                    <ReactAsyncSelect
                                                        placeholder="Search..."
                                                        // defaultOptions
                                                        key={`select_${index}_${lodash.get(formValues, `conditions[${index}].type`)}`}
                                                        loadOptions={inputValue => this.loadProductOptionsDelay(inputValue)}
                                                        value=""
                                                        blurInputOnSelect={true}
                                                        noOptionsMessage={({ inputValue }) => {
                                                            if (inputValue.length === 0) {
                                                                return (<span>Please enter keyword(s) to search product.</span>)
                                                            } else {
                                                                return (<span>Not found</span>)
                                                            }
                                                        }}
                                                        onChange={(value) => {
                                                            this.addOrCondition(index, value)
                                                        }}
                                                        menuListType="sku"
                                                        components={{ MenuList, Option: this.renderCustomOption }}
                                                        filterOption={createFilter({ignoreAccents: false})}
                                                    />
                                                    :
                                                    <ReactAsyncSelect
                                                        placeholder="Search..."
                                                        value=""
                                                        // defaultOptions
                                                        key={`select_${index}_${lodash.get(formValues, `conditions[${index}].type`)}`}
                                                        loadOptions={inputValue => this.loadCategoryOptionsDelay(inputValue)}
                                                        blurInputOnSelect={true}
                                                        noOptionsMessage={({ inputValue }) => {
                                                            if (inputValue.length === 0) {
                                                                return (<span>Please enter keyword(s) to search category.</span>)
                                                            } else {
                                                                return (<span>Not found</span>)
                                                            }
                                                        }}
                                                        onChange={(value) => {
                                                            this.addOrCondition(index, value)
                                                        }}
                                                        menuListType="category"
                                                        components={{ MenuList, Option: this.renderCustomOption }}
                                                        filterOption={createFilter({ignoreAccents: false})}
                                                    />
                                                }
                                            </>
                                            : null}
                                    </TableCell>
                                    {rewardModalOpen === 'special_price' &&
                                        <TableCell></TableCell>
                                    }
                                    <TableCell width="50px">
                                        {!readOnly &&
                                            <TableActionButton
                                                actionType="delete"
                                                onClick={() => {
                                                    fields.remove(index)
                                                }}
                                            />
                                        }
                                    </TableCell>
                                </TableRow>
                                {this.renderTableHead(conditions, index)}
                            </TableHead>
                            <TableBody>
                                <FieldArray
                                    name={`${conditions}.in`}
                                    component={this.renderOrCondition}
                                    productConditionIndex={`${index}`}
                                    validate={[validateSizeMorethanOne]}
                                />
                            </TableBody>
                        </Table>
                    </React.Fragment>
                ))}
                {error && submitFailed && <div style={{ color: red[500] }}>{error}</div>}
            </React.Fragment>
        )
    }

    getTableOperatorText = (productConditionIndex) => {
        const { formValues } = this.props
        let operator = lodash.get(formValues, `conditions[${productConditionIndex}].operator`)
        return operator ? lodash.upperCase(operator) : ""
    }

    renderFieldText = ({ ...props }) => lodash.get(props, 'input.value')

    renderOrCondition = ({ fields, productConditionIndex, meta: { error, submitFailed } }) => {
        const { classes, readOnly, rewardModalOpen } = this.props
        return (
            <React.Fragment>
                {fields.map((inCondition, index) => (
                    <TableRow key={index} className={classes.tdBordered}>
                        <TableCell
                            style={{
                                paddingRight: "10px"
                            }}>
                            <Field
                                name={`${inCondition}.id`}
                                component={this.renderFieldText}
                                type="text"
                            />
                        </TableCell>
                        <TableCell style={{
                            whiteSpace: "nowrap",
                            maxWidth: "300px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            paddingRight: "10px"
                        }}>
                            <Field
                                name={`${inCondition}.name`}
                                component={this.renderFieldText}
                                type="text"
                            />
                        </TableCell>
                        <TableCell style={{paddingRight: "10px"}}>
                            <Field
                                name={`${inCondition}.qty`}
                                component={CustomInput}
                                formControlProps={{
                                    style: {
                                        paddingTop: "0px",
                                        margin: "0px"
                                    }
                                }}
                                type="text"
                                normalize={normalize.onlyNumber}
                                validate={[validateRequired]}
                                disabled={readOnly}
                            />
                        </TableCell>
                        {rewardModalOpen === 'special_price' &&
                            <TableCell width="190px" style={{paddingRight: "10px"}}>
                                <Field
                                    name={`${inCondition}.value`}
                                    component={CustomInput}
                                    formControlProps={{
                                        style: {
                                            paddingTop: "0px",
                                            margin: "0px"
                                        }
                                    }}
                                    type="text"
                                    normalize={normalize.onlyFloatingTwo}
                                    validate={[validateRequired]}
                                    disabled={readOnly}
                                />
                            </TableCell>
                        }
                        <TableCell style={{ padding: "0px", width: "50px" }}>
                            {!readOnly &&
                                <TableActionButton
                                    actionType="delete"
                                    onClick={() => {
                                        fields.remove(index)
                                    }}
                                />
                            }
                        </TableCell>
                        <TableCell style={{ padding: "0px", width: "50px" }}>
                            {(index < (fields.length - 1)) ? <b>{this.getTableOperatorText(productConditionIndex)}</b> : null}
                        </TableCell>
                    </TableRow>
                ))}
                { error && submitFailed &&
                    <TableRow className={classes.tdBordered}>
                        <TableCell colSpan={rewardModalOpen === 'special_price'?6:5} align="center"><span style={{ color: red[500] }}>{error}</span></TableCell>
                    </TableRow>
                }
            </React.Fragment>
        )
    }

    handleSubmit(submitValues) {
        let { promotionFormValue, dispatch, rewardModalOpen } = this.props
        let conditions = lodash.get(promotionFormValue, 'rewards')
        let rewardType = rewardModalOpen
        lodash.remove(conditions, function (n) {
            return n.type === rewardType
        })

        dispatch(arrayPush('promotion_form', 'rewards', {
            type: rewardType,
            conditions: lodash.get(submitValues, 'conditions'),
            operator: lodash.get(submitValues, 'operator')
        }))
        dispatch({ type: promotionConstants.CLOSE_REWARD_MODAL })

    }

    render() {
        const { rewardModalOpen, classes, dispatch, handleSubmit, readOnly } = this.props
        return (
            <MuiThemeProvider theme={THEME}>
                <Dialog
                    classes={{
                        root: classes.center,
                        paper: classes.modal
                    }}
                    open={(rewardModalOpen === 'free_product') || (rewardModalOpen === 'special_price')}
                    keepMounted
                    aria-labelledby="modal-slide-title"
                    aria-describedby="modal-slide-description"
                    fullWidth={true}
                    maxWidth="md"
                    disableRestoreFocus={true}
                    scroll="body">

                    <DialogTitle
                        disableTypography
                        className={classes.modalHeader}>
                        <h4 className={classes.modalTitle}>
                            <b>{rewardModalOpen === 'free_product' ? "Free Product" : "Buy Product with Special Price"}</b>
                        </h4>
                    </DialogTitle>

                    <form name={FORM_NAME} onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                        <DialogContent
                            id="purchase-product-condition-dialog"
                            className={classes.modalBody}
                            style={{
                                overflow: "visible"
                            }}
                        >
                            <GridContainer>
                                <GridItem xs={8}></GridItem>
                                <GridItem xs={2}>
                                    <Field
                                        name="operator"
                                        type="text"
                                        component={CustomSelect}
                                        formControlProps={{
                                            fullWidth: true,
                                            style: {
                                                position: "relative",
                                                top: "-18px",
                                                textAlign: "center"
                                            }
                                        }}
                                        labelText={""}
                                        outlined
                                        optionsList={[{
                                            value: "AND",
                                            label: "AND"
                                        }, {
                                            value: "OR",
                                            label: "OR"
                                        }]}
                                        disabled={readOnly}
                                        validate={[validateRequired]}
                                    />
                                </GridItem>
                                <GridItem xs={2} style={{ textAlign: "center" }}>
                                    {!readOnly &&
                                        <Button
                                            type="button"
                                            color="success"
                                            style={{ marginTop: "-14px", width: "80px" }}
                                            onClick={this.addCondition.bind(this)}
                                        >Add</Button>
                                    }
                                </GridItem>
                            </GridContainer>

                            <GridContainer>
                                <GridItem xs={12}>
                                    <FieldArray
                                        name="conditions"
                                        component={this.renderRewardCondition}
                                        validate={[validateSizeMorethanOne]}
                                    />
                                </GridItem>
                            </GridContainer>

                        </DialogContent>
                        <DialogActions
                            className={classes.modalFooter}>
                            {!readOnly &&
                                <Button
                                    id={`promotion_free_product_btn_submit`}
                                    type="submit"
                                    style={{ marginRight: "10px" }}
                                    color="primary">
                                    Submit
                                </Button>
                            }
                            <Button
                                id={`promotion_free_product_btn_cancel`}
                                type="button"
                                onClick={() => {
                                    dispatch({ type: promotionConstants.CLOSE_REWARD_MODAL });
                                }}
                                color="white">
                                Cancel
                            </Button>
                        </DialogActions>
                    </form>

                </Dialog>
            </MuiThemeProvider>
        )
    }
}

function mapStateToProps(state) {
    const { rewardModalOpen, formMode } = state.promotion;
    const formValues = getFormValues(FORM_NAME)(state)
    const promotionFormValue = getFormValues('promotion_form')(state)
    return {
        rewardModalOpen, formValues, promotionFormValue, formMode
    };
}

const connectedComponent = connect(mapStateToProps)(PromotionRewardFreeProduct);

export default reduxForm({
    form: FORM_NAME,
    validate: validate,
    enableReinitialize: false
})(withStyles(style)(connectedComponent))
